import { createAsyncThunk } from '@reduxjs/toolkit';
import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';
import { ICRMListResponse } from './index';
import { AdminApiPaths } from '../../../api/APIPaths';

export type TGetCRMList = {
  limit: number;
  offset: number;
  sortKey?: string;
  sortValue?: number;
  country?: string;
  registeredDateFrom?: string;
  registeredDateTo?: string;
  lastClassDateFrom?: string;
  lastClassDateTo?: string;
  nextClassDateFrom?: string;
  nextClassDateTo?: string;
  availableCreditsLTE?: number;
  studentName?: string;
  numberOfPaymentsFrom?: number;
  numberOfPaymentsTo?: number;
};

const apiDataProvider = new APIDataProvider();

export const getCRMList = createAsyncThunk(
  'crm/getCRMList',
  async (data: TGetCRMList) => {
    let path = `${AdminApiPaths.crm}?limit=${data.limit}&offset=${data.offset}`;

    if (data.sortKey) {
      path += `&sortKey=${data.sortKey}`;
    }

    if (data.sortValue !== undefined) {
      path += `&sortValue=${data.sortValue}`;
    }

    if (data.country) {
      path += `&country=${encodeURIComponent(data.country)}`;
    }

    if (data.registeredDateFrom) {
      path += `&registeredDateFrom=${data.registeredDateFrom}`;
    }

    if (data.registeredDateTo) {
      path += `&registeredDateTo=${data.registeredDateTo}`;
    }

    if (data.lastClassDateFrom) {
      path += `&lastClassDateFrom=${data.lastClassDateFrom}`;
    }

    if (data.lastClassDateTo) {
      path += `&lastClassDateTo=${data.lastClassDateTo}`;
    }

    if (data.nextClassDateFrom) {
      path += `&nextClassDateFrom=${data.nextClassDateFrom}`;
    }

    if (data.nextClassDateTo) {
      path += `&nextClassDateTo=${data.nextClassDateTo}`;
    }

    if (data.availableCreditsLTE !== undefined) {
      path += `&availableCreditsLTE=${data.availableCreditsLTE}`;
    }

    if (data.studentName) {
      path += `&studentName=${encodeURIComponent(data.studentName)}`;
    }

    if (data.numberOfPaymentsFrom !== undefined) {
      path += `&numberOfPaymentsFrom=${data.numberOfPaymentsFrom}`;
    }

    if (data.numberOfPaymentsTo !== undefined) {
      path += `&numberOfPaymentsTo=${data.numberOfPaymentsTo}`;
    }

    const response = await apiDataProvider.get<TApiResponse<ICRMListResponse>>(
      path
    );

    return response.data;
  }
);
